import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { Message } from 'src/app/core/class/message';
import { ErrorCode } from 'src/app/core/constants/error-code';
import { TreeModel } from 'src/app/core/models/tree-model';
import { DocumentTemplateService } from 'src/app/core/services/document-template.service';
import { DocumentTypeService } from 'src/app/core/services/document-type.service';
import { DocumentService } from 'src/app/core/services/document.service';
import { TemplateFileService } from 'src/app/core/services/template-file.service';
import { WarningDialogComponent } from 'src/app/modules/dashboard/home/home-enterprise/contract-lot/warning-dialog/warning-dialog.component';
import { DialogPreviewPdfComponent } from 'src/app/modules/dashboard/home/home-enterprise/document-management/dialog-preview-pdf/dialog-preview-pdf.component';
import { DocumentDownloadFalseDialogComponent } from '../document-download-false-dialog/document-download-false-dialog.component';
import { DocumentDownloadSuccessDialogComponent } from '../document-download-success-dialog/document-download-success-dialog.component';
import { WarningComponent } from '../warning/warning.component';

@Component({
  selector: 'app-document-download-dialog',
  templateUrl: './document-download-dialog.component.html',
  styleUrls: ['./document-download-dialog.component.scss']
})
export class DocumentDownloadDialogComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  formValue: FormGroup;
  templateTypes = []
  serviceTypesFilterCtrl: FormControl = new FormControl()
  categoryList = [];
  listServiceTypes = [];
  listTypes: Observable<any>;
  searchTypeCtrl: FormControl = new FormControl(null);
  loadingSearchType = false;
  constructor(
    private fb: FormBuilder,
    private toast: ToastrService,
    private message: Message,
    private dialog: MatDialog,
    private documentTypeService: DocumentTypeService,
    private documentTemplateService: DocumentTemplateService,
    public dialogRef: MatDialogRef<DocumentDownloadDialogComponent>,
    private templateFileService: TemplateFileService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.getServiceType();
    this.initForm();
    this.getInitData()
    this.serviceTypesFilterCtrl.valueChanges.subscribe(() => {
      this.templateTypes = this.templateTypes.filter(item => {
        return item.name && item.name.toLowerCase().includes(this.serviceTypesFilterCtrl.value.toLowerCase())
      })
    })
  }

  initForm() {
    this.formValue = this.fb.group({
      itemTypeId: new FormControl(null, Validators.required),
      name: new FormControl(this.data.name, Validators.required),
      description: new FormControl(''),
    })
  }

  getInitData() {
    this.searchDocumentType();
    this.documentTypeService.getListCategory(this.data.id).subscribe(
      res => {
        console.log(res);
        this.categoryList = res.data.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
      }
    )
  }
  getServiceType(): void {
    const enterpriseId = localStorage.getItem('enterpriseId');
    this.documentTypeService
      .getServiceTypes(enterpriseId)
      .subscribe((result) => {
        const { data } = result;
        this.listServiceTypes = data;
        this.searchTypeCtrl.patchValue('');
      });
  }

  searchDocumentType() {
    // listen for search field value changes
    this.listTypes = this.searchTypeCtrl.valueChanges
      .pipe(
        startWith(''),
        map((value) => {
          if (!value) {
            return this.listServiceTypes;
          }
          return this.listServiceTypes.filter((st) => {
            const optionLabel = `${st.name}`;
            return optionLabel.toLowerCase().includes(value.trim().toLowerCase());
          });
        })
      );
  }

  focusOut(field: string) {
    if (!this.formValue.controls[field].value) {
      return
    }
    const value = this.formValue.controls[field].value.trim();
    this.formValue.controls[field].patchValue(value);
  }

  onDownload() {
    if(!this.formValue.valid){
      this.formValue.markAllAsTouched();
      return;
    }
    this.blockUI.reset();
    this.blockUI.start('');
    let request = {
      documentTypeEnterpriseId: this.data.id,
      name: this.formValue.value.name,
      serviceType: this.formValue.value.itemTypeId,
      description: this.formValue.value.description,
      categories: []
    }
    request.categories = this.categoryList ? this.categoryList.map(item => item.categoryId) : []

    this.documentTypeService.downloadTemplate(request).subscribe(res => {
      this.dialog.closeAll()
      this.blockUI.stop();
      if(res && res.success){
      this.documentTemplateService.downloadTemplateSuccess.next(true);
      this.dialog.open(DocumentDownloadSuccessDialogComponent, {
        data: {
          selectedFrom: this.data.name,
          name: request.name,
          categoryList: this.categoryList
        },
      })
      }else{
        this.dialog.open(DocumentDownloadFalseDialogComponent, {
          data: {
            selectedFrom: this.data.name,
            message: res.message,
            code: res.code,
            name: request.name
          },
        })
      }
    })
  }

  closeDialog() {
      const dialog = this.dialog.open(WarningComponent, {
        width: "40%",
        data: this.message.getMessage("messages.confirm_cancel"),
      });
      dialog.afterClosed().subscribe((ref) => {
        if (ref) {
          this.formValue.reset();
          dialog.close()
          this.dialogRef.close();
          return;
        }
      });
      return;
  }

  preview(element) {
    this.templateFileService.getSystemTemplateFile(element.documentTemplateId)
      .subscribe((res) => {
        if (res && res.code === ErrorCode.NotPermissionTemplate) {
          this.toast.error(this.message.getMessage('messages.check_permission'));
          return;
        }
        if (res.data[0]) {
          this.templateFileService.getContentFileByUrl({
            type: 'TEMPLATE_PDF',
            url: res.data[0].file.pdfUrl,
          }).subscribe((response) => {
            if (!response) {
              return;
            }
            this.dialog.open(DialogPreviewPdfComponent, {
              width: '80%',
              data: {
                file: response,
                name: element.name,
                element: element
              },
            });
          });
        }
      });
  }

}
